import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#174D77",
        secondary: "#0c283e",
        accent: "#8c9eff",
        error: "#b71c1c",
        success: "#01612e",
        info: "#466F8F",
      },
    },
  },
});
